import React from "react";
import { Typography } from "@mui/material";

export default function ErrorMessage({ text }) {
  return (
    <Typography
      sx={{
        fontSize: 12,
        display: "block",
        m: 0,
        p: 0,
        whiteSpace: "pre-wrap",
        color: "red",
      }}
      textTransform="none"
    >
      {text}
    </Typography>
  );
}